import type { IconData } from '@stacksjs/iconify-core'

export const hairdryerF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6 10.286V1.714h3.2a6 6 0 0 1 8.686 8.27l1.925 5.286a3 3 0 1 1-5.638 2.052l-1.982-5.444a6 6 0 0 1-2.99-1.592zm-2 0H2a2 2 0 0 1-2-2V3.714a2 2 0 0 1 2-2h2zM12 5a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default hairdryerF
